import type { CSSObject } from '@ant-design/cssinjs'
import { Keyframes } from '@ant-design/cssinjs'

// ── 紫蓝色系 ──
export const purple = {
  50: '#f5f3ff',
  100: '#ede9fe',
  200: '#ddd6fe',
  300: '#c4b5fd',
  400: '#a78bfa',
  500: '#8b5cf6',
  600: '#7c3aed',
  700: '#6d28d9',
  800: '#5b21b6',
  900: '#4c1d95',
}

// ── Glow 阴影 ──
export const glowSm = `0 0 10px ${purple[500]}40, 0 0 20px ${purple[600]}20`
export const glowMd = `0 0 15px ${purple[500]}50, 0 0 30px ${purple[600]}25`
export const glowLg = `0 0 20px ${purple[500]}60, 0 0 40px ${purple[600]}30`

// ── 渐变 ──
export const primaryGradient = `linear-gradient(135deg, ${purple[600]}, ${purple[500]})`
export const primaryGradientHover = `linear-gradient(135deg, ${purple[500]}, ${purple[400]})`
export const subtleGradient = `linear-gradient(135deg, ${purple[600]}08, ${purple[400]}12)`
export const borderGradient = `linear-gradient(135deg, ${purple[500]}60, ${purple[300]}40)`

// ── 呼吸动画 ──
export const pulseKeyframes = new Keyframes('hero-pulse', {
  '0%, 100%': { boxShadow: `0 0 8px ${purple[500]}30` },
  '50%': { boxShadow: `0 0 16px ${purple[500]}50` },
})

// ── shimmer 动画 ──
export const shimmerKeyframes = new Keyframes('hero-shimmer', {
  '0%': { backgroundPosition: '-200% 0' },
  '100%': { backgroundPosition: '200% 0' },
})

// ── 通用过渡 ──
export const transition = 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)'
export const transitionFast = 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)'

// ── Glass 效果 ──
export const getGlassStyle = (isDark: boolean): CSSObject => ({
  backdropFilter: 'blur(12px) saturate(180%)',
  WebkitBackdropFilter: 'blur(12px) saturate(180%)',
  background: isDark
    ? 'rgba(39, 39, 42, 0.75)'
    : 'rgba(255, 255, 255, 0.72)',
})

// ── Focus ring ──
export const getFocusRing = (): CSSObject => ({
  outline: `2px solid ${purple[500]}`,
  outlineOffset: '2px',
})

// ── Glow border (pseudo-element) ──
export const getGlowBorder = (lineWidth: number = 1): CSSObject[] => [
  {
    content: '\"\"',
    position: 'absolute',
    inset: -lineWidth,
    padding: lineWidth,
    borderRadius: 'inherit',
    background: borderGradient,
    zIndex: 0,
    transition,
    display: 'block',
    pointerEvents: 'none',
    opacity: 0,
    mask: [
      'linear-gradient(#fff 0 0) content-box',
      'linear-gradient(#fff 0 0)',
    ].join(','),
    maskComposite: 'xor',
    WebkitMask: [
      'linear-gradient(#fff 0 0) content-box',
      'linear-gradient(#fff 0 0)',
    ].join(','),
    WebkitMaskComposite: 'exclude',
  },
  { WebkitMaskComposite: 'xor' },
]
